import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Tooltip } from '@material-ui/core';
import moment from 'moment';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import { getCookie } from '../../utils/CookieHelper';
import Service from '../../config/networkutils'
import OverwriteSchedules from './OverwriteSchedules';

const token = getCookie("ptd_ts_token");



class AllocateSchedules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addData: [{
                from: moment().weekday(1).format('YYYY-MM-DD'),
                to: moment().weekday(1).add(1, 'week').format('YYYY-MM-DD'),
                qty: 0,
            }],
            addBtnDisabled: false,
            columns: [],
            existingAllocationData: [],
            disciplineDropdown: [],
            splitDemandDialog: false,
            pendingSplitDemand: false,
        }
    }

    handleCustomToDate = (date, i) => {
        if (moment(date).format('dddd') === 'Monday') {
            let data = this.state.addData
            data[i]['to'] = moment(date).format('YYYY-MM-DD')
            this.setState({ addData: data }, () => {
                if (this.props.tabChangeAlert)
                    this.props.tabChangeAlert(true)
            })
        } else {
            this.props.enqueueSnackbar('Please select Monday as To date', {
                variant: 'warning'
            });
        }
    }

    handleCustomFromDate = (date, i) => {
        if (moment(date).format('dddd') === 'Monday') {
            let data = this.state.addData
            data[i]['from'] = moment(date).format('YYYY-MM-DD')
            this.setState({ addData: data }, () => {
                if (this.props.tabChangeAlert)
                    this.props.tabChangeAlert(true)
            })
        } else {
            this.props.enqueueSnackbar('Please select Monday as From date', {
                variant: 'warning'
            });
        }
    }

    handleCustomQty = (e, i) => {
        let data = this.state.addData
        data[i]['qty'] = e.target.value
        this.setState({ addData: data }, () => {
            if (this.props.tabChangeAlert)
                this.props.tabChangeAlert(true)
        })
    }

    handleCustomDescipline = (e, i) => {
        let data = this.state.addData
        data[i]['descipline'] = e.target.value
        this.setState({ addData: data })
    }

    addQty = () => {
        let data = this.state.addData
        data.push({
            from: moment().weekday(1).format('YYYY-MM-DD'),
            to: moment().weekday(1).add(1, 'week').format('YYYY-MM-DD'),
            qty: 0,
        })
        this.setState({ addData: data }, () => {
            if (this.props.tabChangeAlert)
                this.props.tabChangeAlert(true)
        })
    }

    removeQty = (i) => {
        let data = this.state.addData
        data.splice(i, 1)
        this.setState({ addData: data }, () => {
            if (this.props.tabChangeAlert)
                this.props.tabChangeAlert(true)
        })
    }

    backToMainMenu() {
        if (this.props.getMenu) {
            this.props.getMenu('main-menu')
        }
        if (this.props.tabChangeAlert) {
            this.props.tabChangeAlert(false)
        }
    }


    addSchedule(value) {
        this.setState({ addBtnDisabled: true })

        var addData = this.state.addData
        let go = true
        for (let i = 0; i < addData.length; i++) {
            const element = addData[i];
            if (!element.from || !element.to) {
                this.props.enqueueSnackbar('Please select From and To date', {
                    variant: 'warning'
                });
                this.setState({ addBtnDisabled: false })
                return
            } else if (element.qty <= 0) {
                this.props.enqueueSnackbar('Qty should be greater than 0', {
                    variant: 'warning'
                });
                this.setState({ addBtnDisabled: false })
                return
            } else if (element.from && element.to && moment(element.to).isBefore(moment(element.from))) {
                go = false
                break
            }
        }
        if (!go) {
            this.props.enqueueSnackbar('To date should be greater than From date', {
                variant: 'warning'
            });
            this.setState({ addBtnDisabled: false })
            return
        }
        let data = {
            "crm": this.props.crm.crm_id,
            "overwrite": value,
            "shdl_data": this.state.addData,
            'descipline': this.props.crm.descipline ? this.props.crm.descipline : this.props.crm.discipline ? this.props.crm.discipline[0] : this.props.role ? this.props.role.descipline : ''
        }
        if (this.state.pendingSplitDemand || this.state.existingAllocationData?.shdl_data?.length > 0) {
            data['split_demand'] = true
        }
        let url = ''
        if (this.props.isAtr) {
            data['atr_record'] = this.props.atr.id
            url = '/api/atr/records/allocate_atr_to_staff_location/'
        } else {
            data["emp"] = this.props.user.id
            url = '/api/prp/rolenew/allocate_user_to_staff_location/'
        }

        Service.post(url, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        })
            .then(res => {
                if (this.props.refreshData) {
                    this.props.refreshData()
                }
                if (this.props.closeDialog) {
                    this.props.closeDialog(true)
                }
                if (this.props.isAtr) {
                    this.props.enqueueSnackbar('Employee added to ATR successfully', {
                        variant: 'success'
                    })
                } else {
                    this.props.enqueueSnackbar('Employee added successfully', {
                        variant: 'success'
                    });
                }
                this.setState({ addBtnDisabled: false, confirmationDialog: false, splitDemandDialog: false, pendingSplitDemand: false, existingAllocationData: {} }, () => {
                    if (this.props.tabChangeAlert)
                        this.props.tabChangeAlert(false)
                })
            })
            .catch(error => {
                if (error && error.status === 406) {
                    this.setState({ existingAllocationData: error.data, splitDemandDialog: false },() =>{
                        this.setState({ confirmationDialog: true })
                    })
                }
                else if (error && error.status === 409) {
                    this.setState({ existingAllocationData: error.data}, () => {
                        this.setState({ splitDemandDialog: true, pendingSplitDemand: true })
                    })
                }
                else if (error && error.status === 406) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                }
                else if (error && error.status === 400) {
                    this.props.enqueueSnackbar(error.data.message || error.data.msg, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    })
                }
                this.setState({ addBtnDisabled: false })
                console.log(error)
            })

    }

    addPromoteSchedule() {
        var addData = this.state.addData
        let go = true
        for (let i = 0; i < addData.length; i++) {
            const element = addData[i];
            if (!element.from || !element.to) {
                this.props.enqueueSnackbar('Please select From and To date', {
                    variant: 'warning'
                });
                this.setState({ addBtnDisabled: false })
                return
            } else if (element.qty <= 0) {
                this.props.enqueueSnackbar('Qty should be greater than 0', {
                    variant: 'warning'
                });
                this.setState({ addBtnDisabled: false })
                return
            } else if (element.from && element.to && moment(element.to).isBefore(moment(element.from))) {
                go = false
                break
            }
        }

        if (!go) {
            this.props.enqueueSnackbar('To date should be greater than From date', {
                variant: 'warning'
            });
            this.setState({ addBtnDisabled: false })
            return
        }

        if (this.props.isPromotion) {
            this.props.isPromotion(this.state.addData)
        }
    }

    addDemandwithoutEmployee() {
        this.setState({ addBtnDisabled: true })

        var addData = this.state.addData
        let go = true
        for (let i = 0; i < addData.length; i++) {
            const element = addData[i];
            if (!element.from || !element.to) {
                this.props.enqueueSnackbar('Please select From and To date', {
                    variant: 'warning'
                });
                this.setState({ addBtnDisabled: false })
                return
            } else if (element.qty <= 0) {
                this.props.enqueueSnackbar('Qty should be greater than 0', {
                    variant: 'warning'
                });
                this.setState({ addBtnDisabled: false })
                return
            }
            else if (element.from && element.to && moment(element.to).isBefore(moment(element.from))) {
                go = false
                break
            }
        }

        if (!go) {
            this.props.enqueueSnackbar('To date should be greater than From date', {
                variant: 'warning'
            });
            this.setState({ addBtnDisabled: false })
            return
        }

        let data = {
            "crm": this.props.crm.crm_id,
            'role': this.props.user.role_id,
            'descipline': this.props.crm.descipline ? this.props.crm.descipline : this.props.crm.discipline ? this.props.crm.discipline[0] : this.props.role ? this.props.role.descipline : '',
            "shdl_data": this.state.addData
        }
        Service.post('/api/prp/rolenew/allocate_role_and_demand_with_no_emp/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        })
            .then(res => {
                if (this.props.closeDialog) {
                    this.props.closeDialog()
                }
                if (this.props.tabChangeAlert) {
                    this.props.tabChangeAlert(false)
                }
                this.props.enqueueSnackbar('Demand added successfully', {
                    variant: 'success'
                });
                this.setState({ addBtnDisabled: false })
            })
            .catch(error => {
                if (error && error.status === 302) {
                    this.setState({ existingAllocationData: error.data, confirmationDialog: true })
                }
                else if (error && error.status === 406) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    })
                }
                this.setState({ addBtnDisabled: false })
                console.log(error)
            })


    }


    componentDidMount() {
        if (this.props.getDialogSize) {
            this.props.getDialogSize('md')
        }
    }

    handleCustomDiscipline(event, index) {
        const { value } = event.target;
        const newData = [...this.state.addData];
        newData[index].descipline = value;
        this.setState({ addData: newData });
    }

    addAtrSchedule() {

    }

    render() {
        const formatSplitDemandDate = (date) => {
            if (!date) {
                return '-'
            }
            const formattedDate = moment(date)
            return formattedDate.isValid() ? formattedDate.format('DD-MM-YYYY') : date
        }

        const allocationResponse = this.state.existingAllocationData || {};
        const responseData = allocationResponse.data && typeof allocationResponse.data === 'object'
            ? allocationResponse.data
            : allocationResponse;
        const allocationRecords = Array.isArray(responseData)
            ? responseData
            : Array.isArray(responseData.data)
                ? responseData.data
                : [responseData];
        const scheduleData = allocationRecords.reduce((schedules, record) => {
            const nestedSchedules = Array.isArray(record?.shdl_data)
                ? record.shdl_data
                : Array.isArray(record?.schedule_data)
                    ? record.schedule_data
                    : Array.isArray(record?.schedules)
                        ? record.schedules
                        : Array.isArray(record?.demand_data)
                            ? record.demand_data
                            : [];

            if (nestedSchedules.length === 0) {
                return schedules.concat({ ...record });
            }

            return schedules.concat(nestedSchedules.map((schedule) => ({
                ...record,
                ...schedule,
            })));
        }, []);
        const getScheduleStartDate = (schedule) => schedule?.demand_start_date || schedule?.from || schedule?.start_date;
        const getScheduleEndDate = (schedule) => schedule?.demand_end_date || schedule?.to || schedule?.end_date;
        const getDemandDateFields = (schedule) => [
            { label: 'Demand Start Date', value: formatSplitDemandDate(getScheduleStartDate(schedule)) },
            { label: 'Demand End Date', value: formatSplitDemandDate(getScheduleEndDate(schedule)) },
        ];
        const formatFieldLabel = (field) => field.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
        const formatFieldValue = (field, value) => {
            if (value === null || value === undefined || value === '') {
                return '-';
            }
            if (field.toLowerCase().includes('date')) {
                return formatSplitDemandDate(value);
            }
            if (typeof value === 'object') {
                return JSON.stringify(value);
            }
            return String(value);
        };
        const getDisplayFields = (schedule) => Object.entries(schedule)
            .filter(([, value]) => !Array.isArray(value) && typeof value !== 'function')
            .map(([field, value]) => ({
                label: formatFieldLabel(field),
                value: formatFieldValue(field, value),
            }));
        const scheduleEndsBeforeEmployeeStarts = scheduleData.length > 0 && scheduleData.every((schedule) =>
            moment(getScheduleEndDate(schedule)).isBefore(moment(this.props.isAtr ? schedule?.candidate_start_date : schedule?.employee_start_date))
        )

        return (
            <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} >

                <Box display={'flex'} flexDirection={'row'} width={'100%'} >
                    {this.props.addDemandwithoutEmployee ? <h3>{this.props.crm?.crm_name}</h3> :
                        this.props.isAtr ? <h3>{this.props.crm?.crm_name + " --> " + this.props.atr?.owner + " (" + this.props.atr?.bbuk_number + ")"}</h3> :
                            <h3>{this.props.crm?.crm_name + " --> " + this.props.user?.last_name + ", " + this.props.user?.first_name + " (" + this.props.user?.role_name + ")"}</h3>}
                </Box>
                <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                    <Box display={'flex'} flexDirection={'row'} width={'100%'} >
                        <Tooltip title="Add Schedule">
                            <IconButton size='small' onClick={() => this.addQty()}>
                                <AddCircleOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    {
                        this.state.addData.map((element, i) =>
                            <Box alignItems='center' display='flex' flexDirection='row' justifyContent={'center'} m={1}>
                                <Box marginRight={'10px'}>
                                    <Tooltip title="Remove Schedule">
                                        <IconButton size='small' onClick={() => this.removeQty(i)} disabled={this.state.addData.length === 1}>
                                            <RemoveCircleOutlineOutlinedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                {this.props.promotion ? null :
                                    <Box marginRight={'10px'} marginTop={'10px'}>
                                        <Box style={{ fontSize: "10px", color: '#737373' }}>Discipline</Box>
                                        <Box fontSize={'12px'} display={'flex'} color={'#4d4d4d'} flexDirection={'row'} justifyContent={'left'} style={{ boxSizing: 'border-box', border: '1px solid #4d4d4d', borderRadius: '5px', height: '100%', width: '100%', padding: '5px' }}>
                                            {this.props.crm?.descipline ? this.props?.disciplineObj[this.props.crm?.descipline] : this.props.crm?.discipline ? this.props?.disciplineObj[this.props.crm?.discipline[0]] : this.props.role ? this.props.disciplineObj[this.props?.role?.descipline] : ''}
                                        </Box>
                                    </Box>}
                                <Box marginRight={'10px'}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id={'from'}
                                            label="From"
                                            value={element.from ? element.from : undefined}
                                            error={element.from && element.to && moment(element.to).isBefore(moment(element.from))}
                                            onChange={(e) => this.handleCustomFromDate(e, i)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Box>
                                <Box marginRight={'10px'}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id={'to'}
                                            label="To"
                                            value={element.to ? element.to : undefined}
                                            error={element.from && element.to && moment(element.to).isBefore(moment(element.from))}
                                            onChange={(e) => this.handleCustomToDate(e, i)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Box>
                                <Box marginTop={'5px'}>
                                    <TextField
                                        id={'qty'}
                                        label="Qty"
                                        type="number"
                                        style={{ width: 60 }}
                                        margin="dense"
                                        value={element.qty}
                                        onChange={(e) => this.handleCustomQty(e, i)}
                                    />
                                </Box>

                            </Box>
                        )}
                </Box>

                <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} width={'100%'} m={1}>
                    {(this.props.allocationData?.prj) || (this.props.isRemoveBackButton) ? null :
                        < Button size='small' variant="contained" color="primary" onClick={() => this.backToMainMenu()} style={{ marginRight: "10px" }}>
                            Back
                        </Button>
                    }
                    {
                        this.props.isPromotion ?
                            <Button style={{ marginRight: "10px" }} size='small' variant="contained" color="primary" onClick={() => { if (this.props.closeDialog) { this.props.closeDialog() } }}>
                                Cancel
                            </Button> : null
                    }
                    <Button size='small' variant="contained" color="primary" disabled={this.state.addBtnDisabled} onClick={() => {
                        if (this.props.isPromotion) {
                            this.addPromoteSchedule()
                        } else if (this.props.addDemandwithoutEmployee) {
                            this.addDemandwithoutEmployee()
                        } else if (this.props.isAtr) {
                            this.addSchedule(false)
                        } else {
                            this.addSchedule(false)
                        }
                    }}>
                        Add
                    </Button>
                </Box>
                <Dialog maxWidth="lg" open={this.state.confirmationDialog} onClose={() => this.setState({ confirmationDialog: false })}>
                    <DialogTitle>Are you sure? Do you want to overwrite the existing schedule?</DialogTitle>
                    <DialogContent>
                        <OverwriteSchedules errorData={this.state.existingAllocationData} />
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={this.state.addBtnDisabled} onClick={() => this.addSchedule(true)} color="primary" size='small' variant='contained'>
                            Proceed
                        </Button>
                        <Button onClick={() => this.setState({ confirmationDialog: false, pendingSplitDemand: false })} color="primary" size='small' variant='contained'>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth maxWidth="sm" open={this.state.splitDemandDialog} onClose={() => this.setState({ splitDemandDialog: false, pendingSplitDemand: false })}>
                    <DialogTitle style={{ paddingBottom: 8 }}>
                        <Box fontSize="20px" fontWeight="bold" color="#263238">
                            {scheduleEndsBeforeEmployeeStarts ? 'Schedule cannot be selected' : 'Split demand?'}
                        </Box>
                        <Box fontSize="13px" color="#607D8B" marginTop="6px">
                            {scheduleEndsBeforeEmployeeStarts ? 'The schedule end date is before the employee start date.' : 'Review the matching employee details before proceeding.'}
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ paddingTop: 8 }}>
                        {scheduleEndsBeforeEmployeeStarts &&
                            <Box style={{ padding: 16, marginBottom: 12, backgroundColor: '#FFF8E1', border: '1px solid #FFE082', borderRadius: 6, color: '#5D4037' }}>
                                None of these schedules can be selected because they end before the employee is available to start.
                            </Box>}
                        <Box display="flex" flexDirection="column" style={{ padding: 16, backgroundColor: '#F7FAFC', border: '1px solid #DDE6ED', borderRadius: 6 }}>
                            <Box fontSize="11px" fontWeight="bold" color="#607D8B" marginBottom="8px" style={{ textTransform: 'uppercase' }}>
                                Schedules ({scheduleData.length})
                            </Box>
                            {scheduleData.map((schedule, index) => {
                                const employeeStartDate = this.props.isAtr ? schedule?.candidate_start_date : schedule?.employee_start_date;
                                const scheduleBlocked = moment(getScheduleEndDate(schedule)).isBefore(moment(employeeStartDate));
                                return (
                                    <Box key={`${schedule?.id || 'schedule'}-${index}`} style={{ padding: 12, marginBottom: 10, backgroundColor: '#FFFFFF', border: `1px solid ${scheduleBlocked ? '#FFE082' : '#DDE6ED'}`, borderRadius: 6 }}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={1}>
                                            <Box fontSize="13px" fontWeight="bold" color="#263238">
                                                Schedule {index + 1}
                                            </Box>
                                        </Box>
                                        <Box display="flex" flexWrap="wrap" style={{ gap: 12 }}>
                                            {getDemandDateFields(schedule).map((field) =>
                                                <Box key={`${index}-${field.label}`} style={{ flex: '1 1 180px', minWidth: 180 }}>
                                                    <Box fontSize="11px" fontWeight="bold" color="#607D8B" marginBottom="4px" style={{ textTransform: 'uppercase' }}>
                                                        {field.label}
                                                    </Box>
                                                    <Box color="#263238" fontSize="14px" style={{ minHeight: 20, wordBreak: 'break-word' }}>
                                                        {field.value}
                                                    </Box>
                                                </Box>
                                            )}
                                            {getDisplayFields(schedule).map((field) =>
                                                <Box key={`${index}-${field.label}-${field.value}`} style={{ flex: field.label === 'Email' ? '1 1 100%' : '1 1 180px', minWidth: 180 }}>
                                                    <Box fontSize="11px" fontWeight="bold" color="#607D8B" marginBottom="4px" style={{ textTransform: 'uppercase' }}>
                                                        {field.label}
                                                    </Box>
                                                    <Box color="#263238" fontSize="14px" style={{ minHeight: 20, wordBreak: 'break-word' }}>
                                                        {field.value}
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                )
                            })}
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ padding: '12px 24px 18px' }}>
                        {scheduleEndsBeforeEmployeeStarts ?
                            <Button onClick={() => this.setState({ splitDemandDialog: false })} color="primary" size='small' variant='contained'>
                                Close
                            </Button>
                            :
                            <>
                                <Button onClick={() => this.setState({ splitDemandDialog: false, pendingSplitDemand: false })} color="primary" size='small'>
                                    Cancel
                                </Button>
                                <Button disabled={this.state.addBtnDisabled} onClick={() => this.addSchedule(false)} color="primary" size='small' variant='contained'>
                                    Proceed
                                </Button>
                            </>
                        }
                    </DialogActions>
                </Dialog>
            </Box >
        );
    }
}

export default withSnackbar(AllocateSchedules);